import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import { CONTACT_PROJECT, CONTACT_QUOTE } from "../../data/services.js"

// Primary enquiry CTAs. Both lead to the existing contact form; the
// `intent` query only changes the heading on the contact page. An optional
// `service` key (from data/services.js) pre-selects that service on the form.
export default function CtaButtons({ tone = "dark", className = "", service }) {
  const withService = (href) => (service ? `${href}&service=${service}` : href)

  const primary =
    tone === "light"
      ? "bg-white text-brand-navy hover:bg-blue-50 focus-visible:ring-white focus-visible:ring-offset-brand-navy"
      : "bg-brand-primary text-white hover:bg-blue-700 focus-visible:ring-brand-primary focus-visible:ring-offset-white"

  const secondary =
    tone === "light"
      ? "border-white/40 text-white hover:bg-white/10 focus-visible:ring-white focus-visible:ring-offset-brand-navy"
      : "border-brand-heading/20 text-brand-heading hover:bg-brand-primarySoft focus-visible:ring-brand-primary focus-visible:ring-offset-white"

  const base =
    "inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-7 py-3 text-base font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"

  return (
    <div className={`flex flex-col gap-3 sm:flex-row ${className}`}>
      <Link to={withService(CONTACT_PROJECT)} className={`${base} ${primary}`}>
        Discuss Your Project
        <ArrowRight aria-hidden="true" className="h-4 w-4" />
      </Link>
      <Link to={withService(CONTACT_QUOTE)} className={`${base} border ${secondary}`}>
        Request a Quote
      </Link>
    </div>
  )
}
